/* Radix landing — vanilla interactions (Shopify-portable, no framework) */
(function () {
  "use strict";

  /* ---- scroll reveal ---- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
    });
  }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
  function bindReveal() {
    document.querySelectorAll(".reveal:not(.is-in)").forEach(function (el) { io.observe(el); });
    // safety: never leave content hidden if IO misses (fires even offscreen)
    setTimeout(function () { document.querySelectorAll(".reveal:not(.is-in)").forEach(function (el) { el.classList.add("is-in"); }); }, 1800);
  }

  /* ---- count up ---- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    var dec = (el.getAttribute("data-dec") | 0);
    var suffix = el.getAttribute("data-suffix") || "";
    var prefix = el.getAttribute("data-prefix") || "";
    var dur = 1100, start = performance.now();
    function tick(now) {
      var p = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      el.textContent = prefix + (dec ? val.toFixed(dec) : Math.round(val).toLocaleString()) + suffix;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = prefix + (dec ? target.toFixed(dec) : target.toLocaleString()) + suffix;
    }
    requestAnimationFrame(tick);
  }
  var ioCount = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); ioCount.unobserve(e.target); } });
  }, { threshold: 0.6 });

  /* ---- before/after slider ---- */
  function initBA(ba) {
    var split = 50;
    function set(x) {
      var r = ba.getBoundingClientRect();
      var pct = ((x - r.left) / r.width) * 100;
      split = Math.max(2, Math.min(98, pct));
      ba.style.setProperty("--split", split + "%");
    }
    var dragging = false;
    function down(e) { dragging = true; set((e.touches ? e.touches[0] : e).clientX); }
    function move(e) { if (!dragging) return; set((e.touches ? e.touches[0] : e).clientX); }
    function up() { dragging = false; }
    ba.addEventListener("mousedown", down);
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", up);
    ba.addEventListener("touchstart", down, { passive: true });
    ba.addEventListener("touchmove", move, { passive: true });
    ba.addEventListener("touchend", up);
    // gentle auto-hint on first reveal
    var hinted = false;
    var ioh = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting && !hinted) {
          hinted = true;
          var a = 50, t0 = performance.now();
          function anim(now) {
            var p = Math.min((now - t0) / 1400, 1);
            var v = 50 + Math.sin(p * Math.PI * 2) * 22 * (1 - p);
            ba.style.setProperty("--split", v + "%");
            if (p < 1) requestAnimationFrame(anim);
          }
          requestAnimationFrame(anim);
          ioh.unobserve(ba);
        }
      });
    }, { threshold: 0.5 });
    ioh.observe(ba);
  }

  /* ---- FAQ accordion ---- */
  function initFaq() {
    document.querySelectorAll(".faq__q").forEach(function (q) {
      q.addEventListener("click", function () {
        var item = q.closest(".faq__item");
        var ans = item.querySelector(".faq__a");
        var open = item.classList.contains("open");
        if (open) { item.classList.remove("open"); ans.style.maxHeight = null; }
        else { item.classList.add("open"); ans.style.maxHeight = ans.scrollHeight + "px"; }
      });
    });
  }

  /* ---- mobile nav ---- */
  function initNav() {
    var nav = document.querySelector(".nav");
    var burger = document.querySelector(".nav__burger");
    if (!nav || !burger) return;
    burger.addEventListener("click", function () { nav.classList.toggle("open"); });
    nav.querySelectorAll(".nav__drawer a").forEach(function (a) {
      a.addEventListener("click", function () { nav.classList.remove("open"); });
    });
  }

  /* ---- sticky mobile buy bar ---- */
  function initBuyBar() {
    var bar = document.querySelector(".buybar");
    var hero = document.querySelector(".hero");
    if (!bar || !hero) return;
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle("show", !e.isIntersecting); });
    }, { threshold: 0 });
    io2.observe(hero);
  }

  /* ---- product gallery carousel ---- */
  function initCarousel(root) {
    var imgs = [].slice.call(root.querySelectorAll(".pdp__img"));
    var thumbs = [].slice.call(root.querySelectorAll(".pdp__thumb"));
    var dotsWrap = root.querySelector(".pdp__dots");
    var i = 0;
    if (dotsWrap) imgs.forEach(function (_, n) {
      var d = document.createElement("button");
      if (n === 0) d.className = "active";
      d.addEventListener("click", function () { go(n); });
      dotsWrap.appendChild(d);
    });
    var dots = dotsWrap ? [].slice.call(dotsWrap.children) : [];
    function go(n) {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function (el, k) { el.classList.toggle("active", k === i); });
      thumbs.forEach(function (el, k) { el.classList.toggle("active", k === i); });
      dots.forEach(function (el, k) { el.classList.toggle("active", k === i); });
    }
    thumbs.forEach(function (t, n) { t.addEventListener("click", function () { go(n); }); });
    var prev = root.querySelector(".pdp__arrow.prev"), next = root.querySelector(".pdp__arrow.next");
    if (prev) prev.addEventListener("click", function () { go(i - 1); });
    if (next) next.addEventListener("click", function () { go(i + 1); });
    // swipe
    var x0 = null;
    var stage = root.querySelector(".pdp__stage");
    stage.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  function init() {
    window.__radixInit = true;
    bindReveal();
    document.querySelectorAll("[data-count]").forEach(function (el) { ioCount.observe(el); });
    document.querySelectorAll(".ba").forEach(initBA);
    document.querySelectorAll("[data-carousel]").forEach(initCarousel);
    initFaq();
    initNav();
    initBuyBar();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  /* ---- Shopify theme editor: re-init a section when it's added/edited ---- */
  document.addEventListener("shopify:section:load", function (e) {
    var s = e.target;
    s.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-in"); });
    s.querySelectorAll(".ba").forEach(initBA);
    s.querySelectorAll("[data-carousel]").forEach(initCarousel);
    // scoped FAQ binding (avoids double-binding the rest of the page)
    s.querySelectorAll(".faq__q").forEach(function (q) {
      q.addEventListener("click", function () {
        var item = q.closest(".faq__item");
        var ans = item.querySelector(".faq__a");
        if (item.classList.contains("open")) { item.classList.remove("open"); ans.style.maxHeight = null; }
        else { item.classList.add("open"); ans.style.maxHeight = ans.scrollHeight + "px"; }
      });
    });
    if (s.querySelector(".nav__burger")) initNav();
    if (s.querySelector(".buybar") || s.querySelector(".hero")) initBuyBar();
  });
})();
